// Auth config must be set before router/unleash imports evaluate,
// so this side-effect import must come first.
import '@/use/use.Auth'

import '@attensi/materia/dist/style.css'
import { createApp } from 'vue'
import { router } from './router'
import { sanitizeHtml } from '@/helpers/helper.sanitize'
import { toastPlugin } from '@attensi/materia'
import { i18n } from './i18n/i18n/i18n'
import App from './App.vue'
import { initializeSentry } from '@/use/use.Sentry'
import { ENV } from './consts'
import { Tabs, Tab } from 'vue3-tabs-component'
import * as Sentry from '@sentry/vue'

import { captureAllErrors } from '@/use/use.captureErrors'
import { appLauncher } from './use/use.AppLauncher'

appLauncher().catch(console.error)

const startApp = async () => {
  if (ENV === 'production') {
    const script = document.createElement('script')
    script.defer = true
    script.src = `https://plausible.attensi.com/js/script.js`
    script.setAttribute('data-domain', 'insights.attensi.com')
    document.head.appendChild(script)
  }

  const resolvedRouter = await router

  const app = createApp(App)
    .use(resolvedRouter)
    .use(toastPlugin)
    .component('tabs', Tabs)
    .component('tab', Tab)
    .use(i18n)
    .directive('sanitize-html', sanitizeHtml)

  await initializeSentry(app, resolvedRouter)

  captureAllErrors()
  app.config.errorHandler = (error) => {
    Sentry.captureException(error)
  }

  await resolvedRouter.isReady()
  app.mount('#app')
}

startApp().catch((error) => {
  console.error('Failed to start app:', error)
  Sentry.captureException(error)
})
